import { useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { useGetTasksQuery } from "../services/tasksApi";
import { useChannelQuery } from "../services/websocketApi.ts";
import { FloatLabel } from "primereact/floatlabel";

export default function ProjectDropdown({ selectedProject, onProjectSelect, className, projects: providedProjects }) {
  const hasProvidedProjects = Array.isArray(providedProjects);
  const {
    data: queriedProjects = [],
    isLoading,
    isFetching,
    isError,
    refetch,
  } = useGetTasksQuery(
    { type: 'project' },
    { skip: hasProvidedProjects }
  );
  const projects = hasProvidedProjects ? providedProjects : queriedProjects;

  const { data: projectEvents } = useChannelQuery('projects');
  const lastProcessedProjectEventKeyRef = useRef(null);
  const refetchProjectsRef = useRef(refetch);

  useEffect(() => {
    refetchProjectsRef.current = refetch;
  }, [refetch]);

  useEffect(() => {
    if (hasProvidedProjects) return;
    const messages = projectEvents?.messages || [];
    const latest = messages[messages.length - 1];
    if (!latest) return;

    const latestKey = latest._id || `${latest.id || ''}-${latest.author || ''}-${latest.message || ''}`;
    if (!latestKey || lastProcessedProjectEventKeyRef.current === latestKey) return;

    lastProcessedProjectEventKeyRef.current = latestKey;
    refetchProjectsRef.current();
  }, [projectEvents?.messages, hasProvidedProjects]);

  const sortedProjects = [...projects].sort((a, b) => a.name.localeCompare(b.name, 'pl'));

  return (
    <div>
      <FloatLabel>
        <Dropdown
          value={selectedProject?._id}
          onChange={(e) => {
            const selected = [ { name:'Wszystkie', _id: 'all' }, ...sortedProjects].find(p => p._id === e.value);
            onProjectSelect(selected);
          }}
          options={[ { name:'Wszystkie', _id: 'all' }, ...sortedProjects]}
          optionLabel="name"
          optionValue="_id"
          placeholder="Wybierz projekt..."
          className={className}
          filter
          loading={isLoading || isFetching}
          emptyMessage={isError ? "Błąd ładowania." : "Brak projektów"}
        />
        <label htmlFor="user-in">Projekt</label>
      </FloatLabel>
    </div>
  );
}